import type { Unit } from '../types';

type IncreaseTimeByUnitParams = {
  time: number;
  duration: number;
  unit: Unit;
};

export function increaseTimeByUnit({
  time,
  duration,
  unit
}: IncreaseTimeByUnitParams) {
  const unitsMapping: Record<Unit, number> = {
    days: duration * 1000 * 60 * 60 * 24,
    hours: duration * 1000 * 60 * 60,
    minutes: duration * 1000 * 60,
    seconds: duration * 1000
  };

  return time + unitsMapping[unit];
}
